import { render, staticRenderFns } from "./Pagetabs.vue?vue&type=template&id=1f26ac67&scoped=true"
import script from "./Pagetabs.vue?vue&type=script&lang=js"
export * from "./Pagetabs.vue?vue&type=script&lang=js"
import style0 from "./Pagetabs.vue?vue&type=style&index=0&id=1f26ac67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26ac67",
  null
  
)

export default component.exports